import Vue from 'vue'

/**
 * 
 * @namespace Helper
 */

/**
 * Разлогиневает пользователя если кто-то зашел под его аккаунтом
 * @property {Object} e Объект ошибки 
 * 
 * @memberof Helper
 */
export const errorHelper = function(e) {
    console.dir('helper', e)
    if (e.response.data.hasOwnProperty('status') && (Number(e.response.status) === 403)) {
        localStorage.removeItem('token');
        localStorage.removeItem('isLoggedIn');

        window.location = '/login'
    }
}


function callNotification(m, type, duration) {
    Vue.$toast[type](m, {
        position: "top-right",
        timeout: duration,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        icon: true,
        rtl: false
    });
}

/**
 * Вызывает toast с собщением
 * @property {String} m Сообщение для toast
 * @property {String} [type] Тип toast 
 * @property {Number} [duration] Период существования подсказки 
 * @example
 * 
 * messageHelper('message', 'error', 5000) or this.$messageHelper('message', 'error', 5000)
 * 
 * @memberof Helper
 */
export const messageHelper = function(m = '', type = 'info', duration = 6000, errorObj = undefined) {
    
    if ((typeof m !== 'string') && (m.length === 0)) {
        throw new TypeError('Неверный тип сообщения для уведомления')
    }

    if (typeof errorObj === 'object') {
        if (errorObj.response.data.hasOwnProperty('message')) {
            callNotification(errorObj.response.data.message, type, duration)
        } else {
            callNotification('Неизвестная ошибка', type, duration)
        }
    } else {
        callNotification(m, type, duration)
    }
}